import { render, staticRenderFns } from "./FranchisesFilter.vue?vue&type=template&id=44722578"
import script from "./FranchisesFilter.vue?vue&type=script&setup=true&lang=js"
export * from "./FranchisesFilter.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports